// extracted by mini-css-extract-plugin
module.exports = {"commonIssues":"style_commonIssues__ZOaxA","loadingIndicator":"style_loadingIndicator__ukKhe","issueCard":"style_issueCard__Gt_5t","issueHeader":"style_issueHeader__2cRrd"};